// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__DCLY7","faq__title":"FAQ_faq__title__2aQFd"};